import { useState, useEffect, useRef } from "react";
import Sidebar from "react-sidebar";
import Srcset from "../Srcset";
import styles from "../../common/ReactSidebar/ReactSidebar.module.scss";
import mobstyles from "../../Header/NavMenu/MobMenu/MobMenu.module.scss";
import { useDispatch } from "react-redux";	
import { openMiniCart } from "@/redux/actions/addToCartAction";
import { bodyOverflow } from "@/helpers/userHelpers";
import { setGlobalActiveTab } from "@/redux/actions/generalAction";
import { useSelector } from "react-redux";
import { deleteCookie, hasCookie, getCookie } from "cookies-next";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { openAccountSidebarFromPwaHeader, openForgotSidebar } from "@/redux/actions/loggedInUser";
import { isMenuVisible, isPwaShowShopMenu, isPwaSubmenuVisible, setSearchIcon } from "@/redux/actions/headerAction";
import { retainFocusInsideDrawer } from "@/helpers/adaHelper";
import { reportError } from '@/helpers/errorHelper';
//Customized using react-sidebar
//Props
//1.mainContent : It is an element on click of which a sidebar should open up
//2.sidebarContent : It is a component containing sidebar details

export default function ReactSidebar({
  mainContent,
  sidebarContent,
  secondaryContent,
  ...props
}) {
  const sideMenuRef = useRef();
  const basketSidebarOpen = useSelector((state) => state.click.open_mini_cart);
  const sidebarCause = useSelector((state) => state.general.sidebar_cause);
  let loginUser = useSelector((state) => state.loginUser.open_account_sidebar);
  const menuVisible = useSelector((state) => state.header.isMenuVisible);
  const engraveSidebarOpen = useSelector((state) => state.click.open_engrave_sidebar);
  const wishlistSidebarOpen = useSelector(
    (state) => state.wishlist.open_wishlist_sidebar
  );
  const pwaShowShopMenu=useSelector(
    (state) => state.header.isPwaShowShopMenu
  );
  const [sidebarOpen, onSetSidebarOpen] = useState(false);
  
  const isTabletView = useMediaQuery("(min-width: 768px) and (max-width: 1024px)")
  const isMobileView = useMediaQuery("(max-width: 767px)")
  const dispatch = useDispatch();	
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const drawerRef = useRef(null);
  const sidebarOpenRef = useRef(sidebarOpen);
  const isDesktop= useMediaQuery("(min-width: 1025px)");
  const isPlpFilter = props.isPlpFilter? true: false;

  function handleSidebarClick(e) {	
    //OS-2770 : to set the active tab flag false
    dispatch(setGlobalActiveTab(false)); 
    dispatch(openForgotSidebar(false));
    //delete the isFavouritePdp when the sidebar is closed
    if (hasCookie("isFavouritePdp")) {
      deleteCookie("isFavouritePdp");
    }
    if(props.selectedIcon === "search") {	
      dispatch(openMiniCart(false));		
    }	
    else handleSidebar(e);	
    document.querySelector(".search_wrapper").classList.remove("shift_back");		
    document.querySelector("body").classList.remove("v-main-none");
  }
  function handleSidebar(e) {
    //OS-2770 : to set the active tab flag false
    
    dispatch(setGlobalActiveTab(false)); 
    //
    if (props.handleSidebar) {
      props.handleSidebar(e);
    }
    //handled the sidebar opening logic for the mini baseket drawer based on the bag icon click
    if (!props.sidebarOpen && !props?.handleSidebar || props?.rootClassName?.startsWith("sections_root_class__PTZwt")) {
      onSetSidebarOpen(e)};
    //handled null check for the sidebarOpenRef
    if (sidebarOpenRef && sidebarOpenRef.current !== undefined) {
      sidebarOpenRef.current = e;
    }
  }

  const handleKeyDown = (e) => {
    if(e?.key == 'Escape'){  
      handleSidebarClick(false)
    }
  }

  const secondaryComp = () =>{
    if(secondaryContent){
      return (
        <div className={`${styles.fix_top}`}>
                <ul className={`${styles.mob_main_menu_ul} ${styles.mob_main_menu_ul_new}`}>
                  <li className={`${styles.mob_back_arrow}`} 
                    onClick={() => {
                      props.backButtonOnClick(false);
                    }}
                  >
                    <Srcset
                      height="30"
                      width="20"
                      alt="Arrow Right"
                      requirePath={true}
                      svgFile={true}
                      src={"images/Icons/Arrow/Right/large.svg"}
                    />
                  </li>
                  </ul>
          </div>
      )
    }
    return null;
  }

  useEffect(() => {
    if (typeof props.sidebarOpen !== "undefined") {
      onSetSidebarOpen(props.sidebarOpen);
      sidebarOpenRef.current = props.sidebarOpen
    }
  }, [props.sidebarOpen]);
  
  useEffect(() => {
    // whenever parent or sub drawers opens, add focus inside the drawer
    if(isDesktop && sidebarOpen && drawerRef?.current){
      drawerRef.current.focus();
    }
  }, [sidebarOpen]);

  useEffect(() => {
    if(pwaShowShopMenu && sideMenuRef?.current){
      sideMenuRef.current.click();
      dispatch(isPwaShowShopMenu(false))
      dispatch(isPwaSubmenuVisible(false))
    }
  }, [pwaShowShopMenu,sideMenuRef]);

  useEffect(() => {
    if (typeof document !== "undefined") {
      let sidebarToggle = sidebarOpen
        if(props.parentSlider){
         sidebarToggle = true
        }
      if(menuVisible || wishlistSidebarOpen || basketSidebarOpen || engraveSidebarOpen) sidebarToggle = true
      if (sidebarToggle) {
        if(isMobileView){
          //Timeout is used only mobile so that shift is background is not visible while opening drawer. 
          setTimeout(() => {
            bodyOverflow();
          }, 300);
        }else{
          bodyOverflow();
        }
      } else {
        bodyOverflow(false);
      }
      //fix for OS-3642
      if(isTabletView){
        document.querySelector("html").classList.add("overflow-hidden-ipmb")
        document.querySelector("html").classList.remove("overflow-hidden")
        ;}
    }

    if(isDesktop){
      // ADA: Tab Indexing
      const node = drawerRef.current;
      if (node) {
        // on focusout, add the focus back to the drawer if drawer is open
        node.addEventListener('focusout', (e) => retainFocusInsideDrawer(e, drawerRef, sidebarOpenRef.current));
      }

      return () => {
        if (node) {
          node.removeEventListener('focusout', (e) => retainFocusInsideDrawer(e, drawerRef, sidebarOpenRef.current));
        }
      };
    }
  }, [sidebarOpen]);

  // Fix for extra tab before wishlist and bag icon
  useEffect(() => {
    if (isMobileView) return; // If the view is mobile, exit early
    try {
      // If the sidebar is not open, update the tabIndex of elements with the class 'no-tab'
      if (!sidebarOpen) {
        const elements = document.querySelectorAll(".no-tab");
        elements?.forEach((ele) => {
          ele.tabIndex = -1;
        });
      }
    } catch (error) {
      reportError("Error updating tabIndex for elements with class 'no-tab", error);// Log any errors encountered during the execution
    }
  }, [sidebarOpen,isMobileView]);

  return (
    <>
      <Sidebar 
        className="col-12 "
        tabindex="-1"
        sidebar={
          <div className={!sidebarOpen && isDesktop ? "v-none" : ""}
            onKeyDown = {handleKeyDown}
            ref={drawerRef}
            role="dialog"
            tabIndex={-1}
          >
            <div
              className={`text-end close_block ${styles.close_block}  ${
                props.mobileStyle ? props.mobileStyle : ""
              }`}
              role="button"
              onClick={() => {
                handleSidebarClick(false);
              }}
            >
              <Srcset
                tabIndex={0}
                svgFile={true}
                src="images/Icons/Cross/Large.svg"
                requirePath={true}
                className={`${
                  styles.cross_icon ? styles.cross_icon : ""
                } ipad_close_icon`}
                height="15"
                width="15"
                alt="cross"
              />
            </div>
            {secondaryContent? <>
              <div className={`${isPWA ? "addTopPadding":""}${mobstyles.mob_top_banner} ${mobstyles.fix_top} ${isPWA && mobstyles.pwa_mob_top_banner}`}>
                <ul className={`${mobstyles.mob_main_menu_ul}`}>
                  <li className={`${isPWA ? "hideback":""} ${mobstyles.mob_back_arrow}`}
                    onClick={() => {
                      handleSidebar(false);
                    }}
                    ref={sideMenuRef}
                  >
                    <Srcset
                      height="30"
                      width="20"
                      alt="Arrow Right"
                      requirePath={true}
                      svgFile={true}
                      src={"images/Icons/Arrow/Right/large.svg"}
                    />
                  </li>
                  {secondaryContent}
                  </ul>                  
              </div>
            </>:''}
            {sidebarContent}
          </div>
        }
        open={sidebarOpen}
        styles={props.styles}
        touchHandleWidth={0}
        onSetOpen={() => {
          handleSidebar(false);
        }}
        // pullRight={true}
        pullRight={props.pullRight}
        sidebarClassName={ `${sidebarCause&&!basketSidebarOpen
          ? `bg-oat no-tab ${styles.sidebar_main} ${styles.full_width}`
          : `bg-oat no-tab ${styles.sidebar_main} ${props.sidebarClassName}`} ${isPWA ? "addTopPadding": isPlpFilter ? "filterTopPadding":" " }`}
          overlayClassName={loginUser ? `account-drawer-open ${styles.overlay_class}` : `${styles.overlay_class}`}
        rootClassName={props.rootClassName}
      >
        <div
          className=""
          onClick={() => {
            handleSidebar(true);
          }}
        >
          {mainContent}
        </div>
      </Sidebar>
    </>
  );
}
